const skills = [
  {
    skill:'HTML',
    img:'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg',
  },
  {
    skill:'CSS',
    img:'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original-wordmark.svg',
  },
  {
    skill:'JAVASCRIPT',
    img:'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg',
  },
  {
    skill:'TYPESCRIPT',
    img:'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg',
  },
  {
    skill:'PYTHON',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg',
  },
  {
    skill:'REACT',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg',
  },
  {
    skill:'REDUX',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg',
  },
  {
    skill:'JEST',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/jest/jest-plain.svg',
  },
  {
    skill:'MOCHA',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/mocha/mocha-plain.svg',
  },
  {
    skill:'CHAI',
    img:'https://camo.githubusercontent.com/7ecbd4531436e4f20c1dba52a4fd4ac367cfcc20a2f62cfe7a10f32da306afc6/687474703a2f2f636861696a732e636f6d2f696d672f636861692d6c6f676f2e706e67',
  },
  {
    skill:'SINON',
    img:'https://sinonjs.org/assets/images/logo.png',
  },
  {
    skill:'BOOTSTRAP',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain.svg',
  },
  {
    skill:'TAILWIND',
    img:'https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg',
  },
  {
    skill:'MYSQL',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg',
  },
  {
    skill:'MONGODB',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg',
  },
  {
    skill:'SEQUELIZE',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/sequelize/sequelize-original.svg',
  },
  {
    skill:'EXPRESS',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original.svg',
  },
  {
    skill:'GITHUB',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/github/github-original.svg',
  },
  {
    skill:'DOCKER',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original.svg',
  },
  {
    skill:'SLACK',
    img:'https://raw.githubusercontent.com/devicons/devicon/master/icons/slack/slack-original.svg',
  },
];

export default skills;